import { useMutation } from '@tanstack/react-query';
import { ContactUsModel } from './types';
import { useApiEssentials } from '../../shared/hooks/useApiEssentials';
import { post } from '../../shared/api/apiService';

async function submitSupportRequest(
  apiUrl: string,
  idToken: string,
  model: Partial<ContactUsModel>,
  isAdvanced: boolean,
): Promise<void> {
  const route = isAdvanced ? '/requests/support' : '/requests/support/guest';
  const { attachments, ...payload } = model;

  // Basic form
  if (!isAdvanced) {
    await post<void>(route, payload, apiUrl, idToken);
    return;
  }

  // Advanced form
  const formData = new FormData();
  const requestBlob = new Blob([JSON.stringify(payload)], {
    type: 'application/json',
  });
  formData.append('request', requestBlob);

  if (attachments && attachments.length > 0) {
    [...attachments].forEach(file => {
      formData.append('attachments', file, file.name);
    });
  }

  await post<void>(route, formData, apiUrl, idToken);
}

export function useSupportRequest(isAdvanced: boolean) {
  const { getIdToken, apiUrl } = useApiEssentials();

  return useMutation({
    mutationFn: async (model: ContactUsModel) => {
      const idToken = isAdvanced ? await getIdToken() : '';
      return submitSupportRequest(apiUrl, idToken, model, isAdvanced);
    },
    retry: false,
  });
}
